import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { UTILS__generation } from '@/utils/UTILS__generation';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { UTILS__graph_ui } from '@/utils/UTILS__graph_ui';
import { ENUM__invocation_type } from '@shared/dto/generation/graph_invoke/_invocations/_base/ENUM__invocation_type';
import { FN_INVOCATION__create_manually_by_type } from '@shared/dto/generation/graph_invoke/_invocations/_base/FN_INVOCATION__create_manually_by_type';
import { FN_GRAPH__layout_move_ovelap_nodes_to_first_free_position } from '@shared/dto/generation/graph_invoke/_templates/_methods/FN_GRAPH__layout_move_ovelap_nodes_to_first_free_position';

interface PROPS {
  type: ENUM__invocation_type;
}

export function G_SIDEBAR__add_node_item({ type }: PROPS) {
  const dispatch = use_dispatch();
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   *
   */

  let { graph } = generation_current.tool;

  /*
   * EVENTS
   */

  async function onClick() {
    let graph_new = graph.clone();

    const node = FN_INVOCATION__create_manually_by_type(type, graph_new);

    graph_new.values_allowed__fill();

    /*
     * LAYOUT
     */

    for (let node of graph_new.nodes__get_all()) {
      node.calculate_node_graph_size();
    }

    FN_GRAPH__layout_move_ovelap_nodes_to_first_free_position(graph_new);

    /*
     * UPDATE
     */

    await UTILS__graph_data.update(graph_new);

    await UTILS__generation.update_tool_name_as_custom(generation_current.tool);

    UTILS__graph_ui.node__select(node.meta.node_id);
  }

  function onDragStart(e: React.DragEvent) {
    dispatch(LOCAL__ui_set_string({ value: type, key: 'g_dragging_invocation_type', valid_values: [] }));

    const preview = document.createElement('div');
    preview.className = 'px-3 py-2 bg-gray-700 text-white text-xs font-semibold rounded border border-gray-600 shadow-lg';
    preview.textContent = type;
    preview.style.position = 'absolute';
    preview.style.top = '-1000px';
    document.body.appendChild(preview);
    e.dataTransfer.setDragImage(preview, 0, 0);
    setTimeout(() => document.body.removeChild(preview), 0);
  }

  function onDragEnd() {
    dispatch(LOCAL__ui_set_string({ value: '', key: 'g_dragging_invocation_type', valid_values: [] }));
  }

  /*
   * HTML
   */

  return (
    // todo: use UI_PRIMITIVE__button
    <UI_PRIMITIVE__button
      {...{ onClick, onDragStart, onDragEnd }}
      disabled={g_general__ui_disabled}
      key={type}
      draggable
      className="w-full h-6 text-xs bg-component hover:bg-component-item text-component-item-foreground  border border-component-border transition-colors"
    >
      <span className="w-full text-left truncate">{type}</span>
    </UI_PRIMITIVE__button>
  );
}
